import { MentorList } from "@modules/study/mentor";
import API from "@unisearch/helpers/api";
import { LayoutMain } from "@unisearch/theme/layout";
import React from "react";

const Mentors = ({ mentor }) => {
  return (
    <LayoutMain
      title="Mentors"
      metaUrl={`${process.env.NEXT_PUBLIC_URL}/mentor-all`}
    >
      <MentorList mentor={mentor} />
    </LayoutMain>
  );
};

export default Mentors;

export async function getServerSideProps() {
  let mentor = [];

  try {
    const mentorList = await API.get(`/mentor/`);

    if (mentorList.isSuccess && mentorList.data) {
      mentor = mentorList.data;
    }

    return {
      props: {
        mentor,
      },
    };
  } catch (err) {
    return {
      props: {
        mentor,
      },
    };
  }
}
